// const defaultRender = (value) => (value ? value : '--');
const defaultRender = (value) => (value ? value : value === 0 ? '0' : '--');

const columns = [
    // {
    //     title: 'Order Number',
    //     dataIndex: 'orderNumber',
    //     render: defaultRender,
    // },
    {
        title: 'Position Id',
        dataIndex: 'positionOperationType',
        render: defaultRender,
    },
    {
        title: 'Ticket Id',
        dataIndex: 'ticketID',
        render: defaultRender,
    },
    {
        title: 'Trade Type',
        dataIndex: 'buySell',
        render: defaultRender,
    },
    {
        title: 'Open Commission',
        dataIndex: 'openCommission',
        render: defaultRender,
    },
    {
        title: 'Close Commission',
        dataIndex: 'closeCommission',
        render: defaultRender,
    },
    {
        title: 'Symbol Id',
        dataIndex: 'symbolID',
        render: defaultRender,
    },
    {
        title: 'Profit Loss',
        dataIndex: 'profitLoss',
        render: defaultRender,
    },
    {
        title: 'Amount',
        dataIndex: 'amount',
        render: defaultRender,
    },
    // {
    //     title: 'Opened From',
    //     dataIndex: 'openedFrom',
    //     render: defaultRender,
    // },
    // {
    //     title: 'Closed From',
    //     dataIndex: 'closedFrom',
    //     render: defaultRender,
    // },
    {
        title: 'Current Rate',
        dataIndex: 'currentPrice',
        render: defaultRender,
    },
    {
        title: 'Open Rate',
        dataIndex: 'openRate',
        render: defaultRender,
    },
    {
        title: 'Close Rate',
        dataIndex: 'closeRate',
        render: defaultRender,
    },
    {
        title: 'Interest',
        dataIndex: 'interest',
        render: defaultRender,
    },
    {
        title: 'Symbol Name',
        dataIndex: 'symbolName',
        render: defaultRender,
    },
    {
        title: 'Open Ticket',
        dataIndex: 'openTicket',
        render: defaultRender,
    },
    {
        title: 'Close Ticket',
        dataIndex: 'closeTicket',
        render: defaultRender,
    },
    // {
    //     title: 'Trader Spread',
    //     dataIndex: 'traderSpread',
    //     render: defaultRender,
    // },
    // {
    //     title: 'SWAP',
    //     dataIndex: 'swap',
    //     render: defaultRender,
    // },
    // {
    //     title: 'Commission',
    //     dataIndex: 'commission',
    //     render: defaultRender,
    // },
    // {
    //     title: 'PNL',
    //     dataIndex: 'profit',
    //     render: defaultRender,
    // },
    // {
    //     title: 'Total PNL',
    //     dataIndex: 'totalProfit',
    //     render: defaultRender,
    // },
    {
        title: 'Stop Loss',
        dataIndex: 'stopLoss',
        render: defaultRender,
    },
    {
        title: 'Take Profit',
        dataIndex: 'takeProfit',
        render: defaultRender,
    },
    {
        title: 'Comment',
        dataIndex: 'comment',
        render: defaultRender,
    },
    {
        title: 'Date Time',
        dataIndex: 'dateTime',
        render: defaultRender,
    },
    {
        title: 'Open Date',
        dataIndex: 'openDateTime',
        render: defaultRender,
    },
    {
        title: 'Close Date',
        dataIndex: 'closeDateTime',
        render: defaultRender,
    },
];

export default columns;